import React from 'react';
import { Button } from 'js/components/main/LeaderboardButton/Button';
import { useNavigate } from 'js/hooks/navigate';
import { getClassNames } from 'js/utils/classNames.util';
import style from './index.scss';

export default ({ trackBackButtonClick, className = '', disabled = false, character = '', backButtonUrl = '' }) => {
    const navigate = useNavigate();
    const onBackButtonClick = () => {
        trackBackButtonClick();
        backButtonUrl && navigate(backButtonUrl);
    };

    return (
        <Button
            size='large'
            color='generic'
            view='secondary'
            variant='rounded'
            disabled={disabled}
            className={getClassNames([
                style.button,
                style.iconOnly,
                className
            ])}
            onClick={onBackButtonClick}
        >
            <span>{character}</span>
        </Button>
    );
};
